"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const page_styled_1 = require("./page.styled");
exports.Page = ({ children }) => {
    return React.createElement(page_styled_1.StyledPage, null, children);
};
exports.PageContent = ({ size, children }) => {
    return React.createElement(page_styled_1.StyledPageContent, { size: size || 'full' }, children);
};
exports.PageSubContent = ({ children }) => {
    return React.createElement(page_styled_1.StyledPageSubContent, null, children);
};
//# sourceMappingURL=Page.js.map